module.exports = __webpack_public_path__ + "img/logo-horizontal-dark.2b6d19fc.svg";